export default __webpack_public_path__ + "static/media/wildlife02.30f4cc1c.png";